<template>
    <div>
      <div class="modal hide fade" id="modalUnit" tabindex="-1" role="dialog" aria-labelledby="modalUnit" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Unit
              </h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                  <div class="button-group">
                    <button type="button" class="btn btn-sm btn-soft-primary" @click="selectUnit" data-dismiss="modal">Select</button>
                    rows:
                    <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                      <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                    </select>
                    <span class="mr-1">
                      Total rows: <b>{{ rowsTotal }}</b>
                    </span>
                  </div>

                  <div class="form-group mx-sm-3 mb-2">
                      <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                  </div>
                  <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                      <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                  </span>
                  <nav aria-label="Page navigation example" class="pull-right">
                      <ul class="pagination">
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                              </a>
                          </li>
                          <li class="page-item">
                              <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                              </a>
                          </li>
                      </ul>
                  </nav>
                </div>
                <table class="table table-item mb-0 table-sm table-hover">
                    <thead>
                        <tr>
                          <th></th>
                          <th v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                            {{ t.name }}
                            <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="9" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                      <tr v-for="u in filterData" v-bind:key="u.id">
                        <td><label class="form-checkbox"><input type="checkbox" :value="u.id" v-model="selected"><i class="form-icon"></i></label></td>
                        <td>{{ u.unit_no }}</td>
                        <td>{{ u.customer }}</td>
                        <td>{{ u.schedule_date | dateFormat('DD/MM/YYYY HH:mm') }}</td>
                        <td>{{ u.start_date | dateFormat('DD/MM/YYYY HH:mm') }}</td>
                        <td>{{ u.finish_date | dateFormat('DD/MM/YYYY HH:mm') }}</td>
                        <td>{{ u.fuel_bar }}</td>
                        <td>{{ u.fuel_total }} {{ u.fuel_uom}}</td>
                      </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pre>{{ dataRaw }}</pre>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UnitModal',
  data () {
    return {
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Unit No.',
        prop: 'unit_no'
      }, {
        name: 'Customer',
        prop: 'customer'
      }, {
        name: 'Schedule',
        prop: 'schedule_date'
      }, {
        name: 'Start',
        prop: 'start_date'
      }, {
        name: 'Finish',
        prop: 'finish_date'
      }, {
        name: 'Bar',
        prop: 'fuel_bar'
      }, {
        name: 'Fuel',
        prop: 'fuel_total'
      }],
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      unitList: state => state.units.unitList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.unitList.length
      } else {
        count = this.unitList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.unitList.length
      } else {
        count = this.unitList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.unitList.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    selectUnit () {
      var array = this.selected
      var arr = this.unitList
      var unit = []
      for (let i = 0; i < array.length; i++) {
        for (let a = 0; a < arr.length; a++) {
          if (arr[a].id === array[i]) {
            unit.push(arr[a])
          }
        }
      }
      this.$emit('selectUnitList', unit)
    }
  }
}
</script>
